// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import { toggleSecondModalClose } from '../../storage/actions/modalsActions';
import { cancelWorkOrder } from '../../storage/actions/workOrdersActions';
import ExplanationInputModal from './ExplenationInputModal';

const CancelWorkOrderExplanationModal = ({
  modalState,
  currentWorkOrder,
  cancelWorkOrder: cancelWorkOrderAction,
  toggleSecondModalClose,
}) => {
  const isActive = modalState?.isOpen && modalState?.type === 'cancel';

  const getReasonForCancelWorkOrder = (reason) => {
    toggleSecondModalClose('explanationInputModal', true);
    cancelWorkOrderAction({
      workOrdersId: [currentWorkOrder._id],
      reason,
    });
  };

  if (!isActive) return null;

  return (
    <ExplanationInputModal
      returnExplanation={getReasonForCancelWorkOrder}
      title="Reason to cancel work order"
      type="cancel"
      isCloseAvailable
    />
  );
};

const mapStateToProps = state => ({
  modalState: state.modalState.explanationInputModal,
  currentWorkOrder: state.workOrder.currentWorkOrder,
});

export default connect(mapStateToProps, {
  cancelWorkOrder,
  toggleSecondModalClose,
})(CancelWorkOrderExplanationModal);
